<template>
  <div>
    <div class="ServerSearchs-title">
      <div>{{$t('schedule_instance_config.timeSwitch')}}</div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('schedule_instance_config.search')">
          <div class="ServerSearchs-topTime">
            <server-searchs-search></server-searchs-search>
          </div>
          <table-server-searchs></table-server-searchs>
        </TabPane>
        <TabPane :label="$t('schedule_instance_config.timeSwitchTask')">
          <div class="ServerSearchs-topTime">
            <server-task-searchs-search></server-task-searchs-search>
          </div>
          <table-server-task-searchs></table-server-task-searchs>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>
<script>
    import ServerSearchsSearch from '../server_searchs/ServerSearchsSearch'
    import TableServerSearchs from '../server_searchs/TableServerSearchs'
    import TableServerTaskSearchs from "../server_searchs/TableServerTaskSearchs";
    import ServerTaskSearchsSearch from "./ServerTaskSearchsSearch";
    export default {
        name: 'ServerSearchs',
        components: {
            ServerSearchsSearch,
            ServerTaskSearchsSearch,
            TableServerSearchs,
            TableServerTaskSearchs
        }
    }
</script>

<style scoped>
    .ServerSearchs-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .ServerSearchs-topTime
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/timer_switchs/server_searchs/ServerSearchs.vue